import PreviewDataTable from './PreviewDataTable'

export default PreviewDataTable
